import React from "react";
import Icon from "@ant-design/icons";
const PeopleSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M7.5 15.9396C6.80589 16.1417 6.07186 16.25 5.31254 16.25C4.08024 16.25 2.91457 15.9647 1.878 15.4565C1.87603 15.4088 1.87504 15.3607 1.87504 15.3125C1.87504 13.414 3.41406 11.875 5.31254 11.875C6.49423 11.875 7.53665 12.4713 8.15536 13.3793M7.5 15.9396V15.9375C7.5 15.0101 7.73764 14.1382 8.15536 13.3793M7.5 15.9396C7.50001 15.9693 7.50027 15.999 7.50077 16.0286C9.0522 16.9627 10.8696 17.5 12.8125 17.5C14.7554 17.5 16.5728 16.9627 18.1242 16.0286C18.1247 15.9983 18.125 15.9679 18.125 15.9375C18.125 13.0035 15.7465 10.625 12.8125 10.625C10.8059 10.625 9.05914 11.7375 8.15536 13.3793M10 5.3125C10 6.8658 11.2592 8.125 12.8125 8.125C14.3658 8.125 15.625 6.8658 15.625 5.3125C15.625 3.7592 14.3658 2.5 12.8125 2.5C11.2592 2.5 10 3.7592 10 5.3125ZM3.125 7.1875C3.125 8.39562 4.10438 9.375 5.3125 9.375C6.52062 9.375 7.5 8.39562 7.5 7.1875C7.5 5.97938 6.52062 5 5.3125 5C4.10438 5 3.125 5.97938 3.125 7.1875Z"
			stroke="#344054"
			strokeWidth="1.00352"
			strokeLinecap="round"
			strokeLinejoin="round"
			// stroke-width="1.00352"
			// stroke-linecap="round"
			// stroke-linejoin="round"
		/>
	</svg>
);
const PeopleIcon = (props) => (
	<Icon component={() => <PeopleSvg {...props} />} />
);

export default PeopleIcon;
